module.exports = __webpack_public_path__ + "media/explosion-1.b4fe1c90.mp3";